const money = (value) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

export default function InvoiceSummary({
  invoice,
  summary,
}) {
  const data = summary || invoice || {};

  return (
    <section className="invoice-summary">
      <div className="invoice-total-box">
        <h3>Resumen de la factura</h3>

        <div className="invoice-total-row">
          <span>Subtotal</span>
          <strong>{money(data.subtotal)}</strong>
        </div>

        <div className="invoice-total-row">
          <span>IVA</span>
          <strong>{money(data.tax)}</strong>
        </div>

        <div className="invoice-total-row">
          <span>Descuento</span>
          <strong>{money(data.discount)}</strong>
        </div>

        <div className="invoice-total-row">
          <span>Total pagado</span>
          <strong>{money(data.paid_amount)}</strong>
        </div>

        <div className="invoice-total-row">
          <span>Saldo pendiente</span>
          <strong>{money(data.pending_amount)}</strong>
        </div>

        <div className="invoice-grand-total">
          <span>Total</span>
          <strong>{money(data.total)}</strong>
        </div>
      </div>
    </section>
  );
}